import { MoveableBookFeature } from './moveable-book-feature';

export class WhiteboardDrawing extends MoveableBookFeature {
    user_id: number;
    page_id: number;
    book_id: number;
    subject_id: number;
    school_grade: number;
    sharing_link: string;
    name = '';
    page: Page;
    user: User;
    color = '#acd8ff';
    icon = 'fa-chalkboard';
    video: string;
    time: string;

    getEndpointName(): string {
        return 'bookDataWhiteboardDrawings';
    }
}

export class Page {
    id: number;
    book_id: number;
    user_book_id: number;
    index: number;
    readspeaker: number;
    image_name: string;
    created_at: string;
    updated_at: string;
    width: number;
    height: number;
    zoom_width: number;
    zoom_height: number;
}

export class User {
    id: number;
}

export interface DrawingAction {
    type: DrawingActionType;
}

export interface DrawingOptions {
    color: string;
    strokeWidth: number;
}

export enum DrawingActionType {
    IDLE, FREEHAND, RECT, CIRCLE, TRIANGLE, LINE, TEXT
}
